import * as React from "react"
import Seo from "@components/seo"
import Layout from "@layout"
import Header from "@layout/header/header-four"
import Footer from "@layout/footer/footer-one"
import PageHeader from "@components/pageheader"
import SectionConsult from "@containers/global/cta-area/section-two"
import AboutArea from "@containers/about-us-mantiz/about-area"
import SectionIcons from "@containers/about-us-mantiz/section-icons"

import { aboutUs } from "../dataMantiz/pages/company/aboutUs/aboutUs"

const ButtonPage = ({ pageContext, location }) => {
  return (
    <Layout location={location}>
      <Seo title={aboutUs.title1} />
      <Header />
      <PageHeader
        pageContext={pageContext}
        location={location}
        title={aboutUs.title2}
        customLabel={aboutUs.title3}
      />
      <main className="site-wrapper-reveal">
        <AboutArea />
        <SectionIcons />
        <SectionConsult />
      </main>
      <Footer />
    </Layout>
  )
}

export default ButtonPage
